import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Articleid from '../../Archives/Articleid/Articleid';
import { Helmet } from 'react-helmet-async';

function ArticlePage() {
  const { article } = useParams();
  const location = useLocation();
  const [articleData, setArticleData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchArticleData = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await fetch(`/api/articles/${article}`);
        if (!response.ok) {
          throw new Error('Article not found');
        }
        const data = await response.json();
        setArticleData(data);
        
        // Update the route state with article data for DynamicTitle
        window.history.replaceState(
          { ...location.state, article: data },
          document.title,
          location.pathname
        );
      } catch (err) {
        console.error('Error fetching article:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchArticleData();
  }, [article, location]);

  if (loading) return <div>Loading article...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      {/* Dynamic meta tags for the article */}
      {articleData && (
        <Helmet>
          <title>{articleData.title} | Journal of Applied Bioanalysis</title>
          <meta name="description" content={articleData.abstract} />
          {articleData.keywords && (
            <meta name="keywords" content={articleData.keywords?.join(', ')} />
          )}
          <meta name="robots" content="index,follow" />
          <link rel="canonical" href={typeof window !== 'undefined' ? window.location.href : ''} />

          {/* Open Graph */}
          <meta property="og:type" content="article" />
          <meta property="og:title" content={articleData.title} />
          <meta property="og:description" content={articleData.abstract} />
          <meta property="og:url" content={typeof window !== 'undefined' ? window.location.href : ''} />
          {articleData.image && (
            <meta property="og:image" content={articleData.image} />
          )}

          {/* Twitter */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={articleData.title} />
          <meta name="twitter:description" content={articleData.abstract} />
          {articleData.image && (
            <meta name="twitter:image" content={articleData.image} />
          )}

          {/* Structured data */}
          <script type="application/ld+json">
            {JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'ScholarlyArticle',
              headline: articleData.title,
              description: articleData.abstract,
              author: articleData.authors
                ? [{ '@type': 'Person', name: articleData.authors }]
                : undefined,
              datePublished: articleData.publishedDate || undefined,
              image: articleData.image || undefined,
              inLanguage: 'en',
              url: typeof window !== 'undefined' ? window.location.href : '',
              isPartOf: { '@type': 'Periodical', name: 'Journal of Applied Bioanalysis' },
              keywords: articleData.keywords?.join(', ') || undefined,
            })}
          </script>
        </Helmet>
      )}
      
      {/* Render the Articleid component with the fetched data */}
      <Articleid params={{ article: articleData || { id: article } }} />
    </div>
  );
}

export default ArticlePage;